import { useEffect, useState, createContext, useCallback } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../reducers/userSlice";

const NODE_ENV = process.env.REACT_APP_NODE_ENV;

const WEBSOCKET_URL =
  NODE_ENV === 'production'
    ? 'wss://athena-server.ssdynamics.com/api'
    : NODE_ENV === 'staging' || NODE_ENV === 'development'
    ? 'wss://athena-staging.ssdynamics.com/api'
    : 'ws://localhost:8080';
    
const SOCKET_RECONNECTION_TIMEOUT = 5000;

export const SocketContext = createContext();

export const SocketProvider = (props) => {
  const userEmail = useSelector(selectUser)?.value?.email;
  const [ws, setWs] = useState(null);

  const connectWebSocket = useCallback(() => {
    const newWebSocket = new WebSocket(`${WEBSOCKET_URL}?email=${userEmail}`);
    setWs(newWebSocket);
  }, [userEmail]);

  const reconnectWebSocket = useCallback(() => {
    console.log('Reconnecting WebSocket...');
    connectWebSocket();
  }, [connectWebSocket]);

  useEffect(() => {
    if (!ws && userEmail) {
      connectWebSocket();
    };
  }, [ws, connectWebSocket, userEmail]);

  useEffect(() => {
    const onError = () => {
      console.log('WebSocket connection error...');
    };

    ws?.addEventListener('error', onError);

    return () => {
      ws?.removeEventListener('error', onError);
    };
  }, [ws, reconnectWebSocket]);

  useEffect(() => {
    const reconnectInterval = setInterval(() => {
      if (!ws || ws.readyState !== WebSocket.OPEN) {
        console.log('Automatically reconnecting WebSocket...');
        connectWebSocket();
      }
    }, SOCKET_RECONNECTION_TIMEOUT);

    return () => {
      clearInterval(reconnectInterval);
    };
  }, [ws, connectWebSocket]);

  const contextValue = { ws, reconnectWebSocket };

  return (
    <SocketContext.Provider value={contextValue}>{props.children}</SocketContext.Provider>
  );
};